import { cssUtil } from "../utils/cssUtil.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export function getBaseStyles(widget, breakpoint) {
    const styles = {};
    const device = widget?.properties?.[breakpoint];
    if (!device || !device.layout) return styles;

    const layout = device.layout;

    // width
    if (layout.width && typeof layout.width !== 'object') {
        styles.width = normalizeDimension(layout.width);
    }

    // height
    if (layout.height && typeof layout.height !== 'object') {
        styles.height = normalizeDimension(layout.height);
    }

    // transform + position
    if (layout.transform) {
        const t = layout.transform;

        if (t.rotate) {
            styles.transform = `rotate(${t.rotate})`;
        }

        if (t.translate) {
            const [x, y] = t.translate.split(",");
            styles.left = normalizeDimension(x);
            styles.top = normalizeDimension(y);
        }
    }

    return styles;
}

function normalizeDimension(value) {
  if (value === null || value === undefined) return "0px";

  if (typeof value === "number") {
    return `${value.toFixed(2)}px`;
  }

  if (typeof value === "string") {
    if (value === "" || value === "auto" || value.includes("%")) {
        return value || "0px";
    }

    const num = parseFloat(value);
    if (isNaN(num)) return value; 

    return `${num.toFixed(2)}px`;
  }

  return "0px";
}

export function renderBackground(context, widget, element) {
    const props = widget?.properties?.desktop;
    if (!props?.background) return;

    const bgStyles = {};

    const bg = props.background;
    if ((bg.type === "color" || bg.type === "image") && bg.color?.type === "solid") {
        bgStyles["background-color"] = cssUtil.getCssColor(bg.color);
    }

    if ((bg.type === "color" || bg.type === "image") && bg.color?.type === "gradient") {
        bgStyles["background"] = cssUtil.getCssGradient(bg.color);
    }

    if (bg.type === "image" || bg.type === "video"){
        let url = `url(${IMAGE_CDN_ENDPOINT}/${bg.media.url})`;
        if(bg.type === "video"){
            url = `url(${IMAGE_CDN_ENDPOINT}/${bg.media.url}/ik-thumbnail.jpg)`;
        }
        bgStyles["background-image"] = url;
        bgStyles["background-repeat"] = 'no-repeat';
        bgStyles["background-size"] = 'cover'
        bgStyles["background-position"] = 'center center';
        bgStyles["opacity"] = bg.opacity / 100;
    }

    element.setAttribute(
        "style",
        element.getAttribute("style") + ";" + cssUtil.toStyleString(bgStyles)
    );
}

export function renderFonts(document, fonts, availableFonts) {
    fonts.forEach((fontId) => {
      const availableFont = availableFonts?.find(
        available => available.id === fontId
      );
  
      if (!availableFont || !availableFont.styleSheet) return;
  
      const alreadyAdded = Array.from(
        document.head.querySelectorAll('link')
      ).some(link => link.href === availableFont.styleSheet);
  
      if (alreadyAdded) return;
      const linksheet = document.createElement("link");
      linksheet.rel = "stylesheet";
      linksheet.type = "text/css";
      linksheet.href = availableFont.styleSheet;
  
      document.head.appendChild(linksheet);
    });
  }
  
  